<div class="text-center mt-4">
  <fgbcl-loading></fgbcl-loading>
</div>
